import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import styled from 'styled-components'

import SanityLink from '../../SanityLink'

export const FooterAccordion = styled(Accordion)`
  && {
    border: 0;
    box-shadow: none;
    border-radius: 0;
    background: transparent;
    border-top: 1px solid ${({ theme }) => theme.colors.coolGray.cool700};

    &:first-child {
      border-radius: 0;
    }

    &:last-child {
      border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool700};
    }

    &.Mui-expanded {
      margin: 0;
    }
  }
`

export const FooterAccordionSummary = styled(AccordionSummary)`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
    font-size: 1.1rem;
    color: ${({ theme }) => theme.colors.coolGray.cool450};
    padding: 5px 15px 1px;
    text-transform: uppercase;
  }
`

export const FooterAccordionDetails = styled(AccordionDetails)`
  && {
    padding: 0 15px;
  }
`

export const FooterExpandIcon = styled(ExpandMoreIcon)`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.coolGray.cool600};
`

export const AccordionItemList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const AccordionItem = styled.li`
  margin: 1rem 0;
`

export const AccordionItemText = styled.div`
  color: ${({ theme }) => theme.colors.coolGray.cool500};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-weight: 100;
  padding-top: 1rem;
  font-size: 1.1875rem;
`

export const LinkEntry = styled(SanityLink)`
  color: ${({ theme }) => theme.colors.grayscale.white};
  font-size: 1.1rem;
  text-transform: uppercase;
  text-decoration: none;
`
